import React from "react";
import {
    Select
} from "antd";
import PropTypes from "prop-types";
const SelectOption = Select.Option;
const SelectOptGroup = Select.OptGroup;

class DatasheetSelectEditor extends React.Component {
    value = this.props.defaultValue
    onSelect = (value) => {
        this.value = value;
    }
    componentWillUnmount() {
        this.props.onCommit(this.value);
    }

    render() {
        return React.createElement(
            Select,
            {
                placeholder: "test",
                mode: this.props.mode || "default",
                showSearch: this.props.showSearch || false,
                onChange: this.onSelect,
                onSearch: this.props.onSearch,
                open: true,
                style:this.props.style || {
                    minWidth: 200
                },
                defaultValue: this.props.defaultValue,
                dropdownMenuStyle: this.props.dropdownMenuStyle,
                disabled: this.props.disabled,
                size: this.props.size || "default"
            },
            this.props.options.map((option, index) => {
                if (option.length >= 0) {
                    return React.createElement(
                        SelectOptGroup,
                        {
                            key: index,
                            label: index
                        },
                        option.map(_ =>
                            React.createElement(
                                SelectOption,
                                {
                                    key: _.label,
                                    value: _.value
                                },
                                _.label
                            )
                        )
                    );
                } else {
                    return React.createElement(
                        SelectOption,
                        {
                            key: option.label,
                            value: String(option.value)    
                        },
                        option.label
                    );
                }
            })
        );
    }
}

DatasheetSelectEditor.propTypes = {
    placeholder: PropTypes.string,
    mode: PropTypes.string,
    showSearch: PropTypes.bool,
    onCommit: PropTypes.func,
    onSearch: PropTypes.func,
    style: PropTypes.object,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    dropdownMenuStyle: PropTypes.string,
    disabled: PropTypes.string,
    size: PropTypes.string,
    options: PropTypes.object,
};

export default DatasheetSelectEditor;